import ChartBox from "components/ChartBox"
import ChartTooltip from "components/Charts/ChartTooltip"
import Pie from "components/Charts/Nivo/Pie"

const data = [
	{
		"id": "presencial",
		"label": "Presencial",
		"value": 445,
	},
	{
		"id": "tele",
		"label": "Tele Atendimento",
		"value": 260,
	},
]

const SchedulesAverage = () => {
	const tooltip = (values: any) => {
		const { datum } = values;
		return (
			<ChartTooltip
				label={`${datum.label}`}
				value={datum.value}
				total={445 + 260}
				color={datum.color}
			/>
		)
	}

	return (
		<ChartBox title="Média de Agendamentos">
			<Pie data={data} tooltip={tooltip} />
		</ChartBox>
	)
}

export default SchedulesAverage
